export const API_KEY="AIzaSyC69xK4g5OKLB3wVZ5BAzC0594DN1sh7A8"; // Get this API key from: https://developers.google.com/custom-search/v1/overview?authuser=1

export default API_KEY;